import { render, staticRenderFns } from "./SeccionMain.vue?vue&type=template&id=41480f9e"
import script from "./SeccionMain.vue?vue&type=script&lang=js"
export * from "./SeccionMain.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports